import { Status } from '@kc-console/common-ui';

import { getEventStatusLabelMap, getEventStatusVariant } from '../model/getEventStatusVariant';

import type { EventStatusType } from '../model/types';

interface EventStatusCellProps {
  status: EventStatusType;
}

/**
 * 이벤트 상태 셀.
 * @description
 * - 상태값에 맞는 아이콘과 라벨을 노출한다.
 * @example
 * <EventStatusCell status="OPENED" />
 */
const EventStatusCell = ({ status }: EventStatusCellProps) => {
  const variant = getEventStatusVariant(status);
  const label = getEventStatusLabelMap()[status] ?? status;

  return <Status status={variant}>{label}</Status>;
};

export default EventStatusCell;
